import { Link } from 'react-router-dom';
import { useThemeContext } from '@/contexts/ThemeContext';

export default function CampaignBanner() {
  const { theme } = useThemeContext();
  const { main, gift, coldbrew } = theme.campaign;

  return (
    <section className="py-16 bg-cream-light overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <div className="relative overflow-hidden rounded-3xl bg-coffee-medium min-h-64">
            <img src={main.image_url} alt={main.title} className="absolute inset-0 w-full h-full object-cover object-top opacity-50" />
            <div className="absolute inset-0 bg-gradient-to-r from-coffee via-coffee/70 to-transparent" />
            <div className="relative z-10 p-8 lg:p-10 flex flex-col justify-between h-full">
              <div>
                <span className="inline-block px-3 py-1 bg-gold/20 text-gold text-xs font-semibold rounded-full mb-4">{main.badge}</span>
                <h3 className="font-serif text-2xl lg:text-3xl font-bold text-white mb-3 whitespace-pre-line">{main.title}</h3>
                <p className="text-sm text-cream/70 max-w-xs">{main.description}</p>
              </div>
              <Link to={main.cta_link} className="mt-6 inline-flex items-center gap-2 px-6 py-2.5 bg-gold hover:bg-gold-dark text-white text-sm font-semibold rounded-xl transition-colors whitespace-nowrap self-start">
                {main.cta_text}<i className="ri-arrow-right-line" />
              </Link>
            </div>
          </div>

          <div className="flex flex-col gap-6">
            <div className="relative overflow-hidden rounded-3xl bg-cream min-h-44">
              <img src={gift.image_url} alt={gift.title} className="absolute inset-0 w-full h-full object-cover object-top opacity-60" />
              <div className="absolute inset-0 bg-gradient-to-r from-coffee-medium/90 to-coffee-medium/40" />
              <div className="relative z-10 p-7 flex flex-col justify-between h-full">
                <div>
                  <p className="text-xs text-gold font-medium uppercase tracking-wider mb-2">{gift.badge}</p>
                  <h3 className="font-serif text-xl font-bold text-white mb-2 whitespace-pre-line">{gift.title}</h3>
                  <p className="text-xs text-white/60">{gift.description}</p>
                </div>
                <Link to={gift.cta_link} className="mt-4 inline-flex items-center gap-1.5 text-gold text-sm font-medium hover:gap-3 transition-all whitespace-nowrap self-start">
                  {gift.cta_text}<i className="ri-arrow-right-line" />
                </Link>
              </div>
            </div>

            <div className="relative overflow-hidden rounded-3xl min-h-44" style={{ background: 'linear-gradient(135deg, #1a3a4a 0%, #0d2233 100%)' }}>
              <img src={coldbrew.image_url} alt={coldbrew.title} className="absolute inset-0 w-full h-full object-cover object-top opacity-40" />
              <div className="absolute inset-0 bg-gradient-to-r from-[#0d2233]/90 to-transparent" />
              <div className="relative z-10 p-7 flex flex-col justify-between h-full">
                <div>
                  <p className="text-xs text-blue-300 font-medium uppercase tracking-wider mb-2">{coldbrew.badge}</p>
                  <h3 className="font-serif text-xl font-bold text-white mb-2 whitespace-pre-line">{coldbrew.title}</h3>
                  <p className="text-xs text-white/60">{coldbrew.description}</p>
                </div>
                <Link to={coldbrew.cta_link} className="mt-4 inline-flex items-center gap-1.5 text-blue-300 text-sm font-medium hover:gap-3 transition-all whitespace-nowrap self-start">
                  {coldbrew.cta_text}<i className="ri-arrow-right-line" />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
